'use client';
import React from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Drawer, DrawerContent, DrawerTitle } from '@/components/ui/drawer';
// import { useGetUserAvatarList } from '../../services/user';
import clsx from 'clsx';
import ModalTitle from '../modal-title';

interface ModalSelectProps {
  /** 弹窗标题 */
  title?: string;
  /** 选项 */
  options?: { label: string, icon?: React.ReactNode, value: string; }[];
  value?: string;
  /** 选中回调 */
  onSelect?: (value: string) => void;
  /** 自定义样式 */
  className?: string;
  /** 关闭弹窗时的回调函数 */
  onClose?: () => void;
  /** 编辑成功时的回调函数 */
  onSuccess?: () => void;
  showBack?: boolean;
}
interface ModalSelectReturnType {
  result?: boolean;
}

const ListItem = ({ title, icon, checked, onClick }: { title: string, icon?: React.ReactNode, checked: boolean, onClick: () => void; }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <div className={clsx('mb-2.5 flex items-center w-full h-[55px] px-[.9375rem] rounded-[8px]', checked ? 'bg-[#2A3546]' : 'bg-transparent', 'box-border border-[1px] border-[#2A3546]')} onClick={handleClick}>
      {icon && <div className='mr-2.5'>{icon}</div>}
      <p className={clsx('font-medium text-xs', checked ? 'text-white' : 'text-tertiary')}>{title}</p>
    </div>
  );
};
// Main Modal Component
const ModalSelect = NiceModal.create<ModalSelectProps>(({
  title = '',
  className,
  onClose,
  options,
  value,
  onSelect,
  showBack = true,
}) => {
  const modal = useModal();

  const handleClose = () => {
    onClose?.();
    modal.resolve(true);
    modal.hide();
  };
  const handleSelect = (newValue: string) => {
    if (newValue === value) {
      handleClose();
      return;
    }
    onSelect?.(newValue);
    modal.resolve(true);
    handleClose();
  };



  return (
    <Drawer onClose={handleClose} open={modal.visible} onOpenChange={(open) => !open && handleClose()}>
      <DrawerTitle></DrawerTitle>
      <DrawerContent className={clsx(
        " bg-surface",
        className
      )}>
        <ModalTitle className='px-3 ' title={title} showBack={showBack} onClose={handleClose} onBack={handleClose} />
        <div className='mt-5 flex flex-col items-center px-3 mb-5'>
          {options?.map((option) => (
            <ListItem
              key={option.value}
              title={option.label}
              icon={option.icon}
              checked={value === option.value}
              onClick={() => handleSelect(option.value)}
            />
          ))}
        </div>
      </DrawerContent>
    </Drawer>
  );
});

ModalSelect.displayName = 'ModalSelect';

// eslint-disable-next-line react-refresh/only-export-components
export const showModalSelect: (props?: ModalSelectProps) => Promise<ModalSelectReturnType> = (props = {}) => {
  return NiceModal.show(ModalSelect, props);
};

export default ModalSelect;